import type { IconProps } from './icon.types'

const MailIcon = (props: IconProps) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='mail-icon'
    {...props}
  >
    <rect x='2' y='4' width='14' height='10' rx='1.5' />
    <path d='M2.5 4.8 9 9.6l6.5-4.8' />
  </svg>
)

export default MailIcon
